/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/

import { Team } from "@src/app/model/team";

export type TenantId = string;
export type uuid = string | number | TenantId;

export class AbstractObjectList {
    itemList: AbstractObject[];
}
export abstract class AbstractObject {
    id: uuid = null; // New Items created in UI will have id = null until saved to server.
    revision?: number = 0;
    name? = '';
    teamId?: TenantId;
    team?: Team;
    createdAt?: number; // date!
    updatedAt?: number; //date!
    deletedAt?: number; // date!
    active?: boolean;

    notes?: string = '';
    deleted?: boolean;

    constructor(data: Partial<AbstractObject> = {}) {
        this.overrideValues(data);
    }

    overrideValues?(data: Partial<AbstractObject> = {}) {
        Object.getOwnPropertyNames(data).forEach((prop) => { this[prop] = data[prop]; });
    }
}
